export const DELETE_REASON_CATEGORY = "DeleteRefundReason";

export type CodeCommonOption = {
  codevalue?: string | number;
  codedisplayname?: string;
  displayorder?: number;
};

/** Sort master-data options by API `displayorder`. */
export function sortCodeCommonByDisplayOrder<T extends { displayorder?: number }>(
  options: T[],
): T[] {
  return [...options].sort((a, b) => {
    const ao = Number(a.displayorder);
    const bo = Number(b.displayorder);
    const aOrd = Number.isFinite(ao) ? ao : 9999;
    const bOrd = Number.isFinite(bo) ? bo : 9999;
    return aOrd - bOrd;
  });
}

export function findDeleteReasonOtherCodeValue(
  options: CodeCommonOption[],
): string {
  const row = options.find(
    (o) =>
      String(o.codedisplayname ?? "")
        .trim()
        .toLowerCase() === "other",
  );
  return row != null ? String(row.codevalue ?? "").trim() : "";
}

export function mapDeleteReasonSelectOptions(
  options: CodeCommonOption[],
): { label: string; value: string }[] {
  return options.map((opt) => ({
    label: String(opt.codedisplayname ?? ""),
    value: String(opt.codevalue ?? ""),
  }));
}

export function buildRefundDeleteReasonForApi(
  selectedCode: string,
  remark: string,
  selectOptions: { label: string; value: string }[],
  otherCode: string,
): string {
  const code = String(selectedCode ?? "").trim();
  if (!code) return "";
  if (otherCode !== "" && code === otherCode) {
    return String(remark ?? "").trim();
  }
  const opt = selectOptions.find((o) => o.value === code);
  return opt ? String(opt.label).trim() : code;
}

export function resolveRefundDeleteReasonPayload(
  selectOptions: { label: string; value: string }[],
  otherCode: string,
  selectedCode: string,
  remark: string,
): { ok: true; deletereason: string } | { ok: false; error: string } {
  if (selectOptions.length > 0) {
    const code = selectedCode.trim();
    if (code === "") {
      return { ok: false, error: "Please select a delete reason." };
    }
    const isOther = otherCode !== "" && code === otherCode;
    if (isOther && remark.trim() === "") {
      return {
        ok: false,
        error: "Remark is required when delete reason is Other.",
      };
    }
    const deletereason = buildRefundDeleteReasonForApi(
      code,
      remark,
      selectOptions,
      otherCode,
    );
    if (deletereason === "") {
      return { ok: false, error: "Delete reason is required." };
    }
    return { ok: true, deletereason };
  }
  const deletereason = remark.trim();
  if (deletereason === "") {
    return { ok: false, error: "Delete reason is required." };
  }
  return { ok: true, deletereason };
}
